import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from '@angular/core';
import { FrameContext } from '@farris/devkit';
import { DatagridComponent } from '@farris/ui-datagrid';
import { ComponentRef } from './component-ref';

@Directive({
  selector: '[datagridRef]'
})
export class DatagridComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: DatagridComponent, public elementRef: ElementRef, public frameContext: FrameContext) {
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component, this.component.id);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }
}
